import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Lab", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Enable dev console to see all output", -1)
const _hoisted_3 = { class: "lab" }
const _hoisted_4 = { class: "center" }
const _hoisted_5 = { style: {"margin-left":"1em"} }

import { onMounted, reactive } from 'vue';
import b from '@/_dev/lab/_lab.bootstrap'
import EffortTimeline from '@/components/Workspaces/persons/_spec/EffortTimelineComponent.vue'
import { SunriseReportRmodel } from '@/app.context/workspace/persons/sunrise.rmodel';


export default /*#__PURE__*/_defineComponent({
  __name: '_LabComponent',
  setup(__props) {


const { test, setup, personMeffort_Lab, lab } = b()

const model: { efforts: SunriseReportRmodel | null } = reactive({ efforts: null })

onMounted(setup)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(personMeffort_Lab) && _unref(personMeffort_Lab)(...args)))
      }, "Meffort Lab"),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(lab) && _unref(lab)(...args)))
      }, "Lab")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        style: {"width":"100%"},
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(test)(model)))
      }, "Test")
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(EffortTimeline, {
        style: {"margin-top":"1em"},
        model: model.efforts
      }, null, 8, ["model"])
    ])
  ], 64))
}
}

})